import { Component } from '@angular/core';
import { BreakpointService } from '@libs/index';

@Component({
  selector: 'app-static-content-online-booking-process',
  templateUrl: './static-content-online-booking-process.component.html',
  styleUrls: ['./static-content-online-booking-process.component.scss'],
})
export class StaticContentOnlineBookingProcessComponent {
  constructor(public breakpointService: BreakpointService) {}
}
